import type { IClassroomQuestionRepository } from './interfaces/IClassroomQuestionRepository'
import type { ClassroomQuestion } from '@/types'
import { getSubcollectionDocuments, orderBy } from '@/services/firestore'

export class FirestoreClassroomQuestionRepository implements IClassroomQuestionRepository {
  async getByClassroomId(classroomId: string): Promise<ClassroomQuestion[]> {
    return getSubcollectionDocuments<ClassroomQuestion>(
      'virtual_classrooms',
      classroomId,
      'classroom_questions',
      [orderBy('order', 'asc')]
    )
  }
}
